import BaseApi from '../BaseApi';

interface ProductManagement {
  // API danh sách các danh mục thiết bị
  DeleteProductMix: (id: any) => Promise<any>;
  UpdateProductMix: (data: any) => Promise<any>;
  CreateNewProductMix: (data: any) => Promise<any>;
  GetInitProductMix: (page: number, size: number) => Promise<any>;
  // API quản  lý dữ liệu các thiết bị
  // + Loại thiết bị
  DeleteProductType: (id: any) => Promise<any>;
  UpdateProductType: (data: any) => Promise<any>;
  CreateProductType: (data: any) => Promise<any>;
  GetProductTypeList: () => Promise<any>;
  SearchProductMix: (
    textValue?: any,
    productTypeId?: any,
    productBranchId?: any,
    productCategoryId?: any,
    isActive?: any
  ) => Promise<any>;
  // + Nhóm sản phẩm
  DeleteProductCate: (id: any) => Promise<any>;
  UpdateProductCate: (data: any) => Promise<any>;
  CreateProductCate: (data: any) => Promise<any>;
  CreateProductCateQuickVAT: (data: any) => Promise<any>;
  GetProductCateList: () => Promise<any>;
  // + Nhãn hiệu thiết bị
  DeleteProductBrand: (id: any) => Promise<any>;
  UpdateProductBrand: (data: any) => Promise<any>;
  CreateProductBrand: (data: any) => Promise<any>;
  GetProductBrandList: () => Promise<any>;
  // + Danh sách lỗi thường gặp
  DeleteRegularWeak: (id: any) => Promise<any>;
  UpdateRegularWeak: (data: any) => Promise<any>;
  UpdateRegularWeakV2: (data: any) => Promise<any>;
  UpdateRegularWeakV3: (data: any) => Promise<any>;
  CreateRegularWeak: (data: any) => Promise<any>;
  CreateRegularWeakV2: (data: any) => Promise<any>;
  CreateRegularWeakV3: (data: any) => Promise<any>;
  CreateArrayRegularWeakV2: (data: any) => Promise<any>;
  GetRegularWeakList: () => Promise<any>;
  GetRegularWeakListV2: () => Promise<any>;
  GetRegularWeakListV3: () => Promise<any>;
  // + Cách xử lý
  GetHandleErrorListV2: () => Promise<any>;
  GetHandleErrorListV3: () => Promise<any>;
  CreateErrorHandleV2: (data: any) => Promise<any>;
  CreateErrorHandleV3: (data: any) => Promise<any>;
  CreateArrayErrorHandleV2: (data: any) => Promise<any>;
  UpdateErrorHandleV2: (data: any) => Promise<any>;
  UpdateErrorHandleV3: (data: any) => Promise<any>;
  DeleteErrorHandleV2: (id: any) => Promise<any>;
  SuggestErrorHandleV2: (data: any) => Promise<any>;
  // + Bộ thiết bị
  DeleteSetProduct: (id: any) => Promise<any>;
  UpdateSetProduct: (data: any) => Promise<any>;
  CreateSetProduct: (data: any) => Promise<any>;
  GetSetProductList: () => Promise<any>;
  GetSetProductById: (id: any) => Promise<any>;

  // Phần quản lý thiết bị (là thiết bị thành phẩm có kèm serial riêng cho thiết bị luôn)
}

const ProductManagementApi: ProductManagement = {
  // API danh sách các danh mục thiết bị
  DeleteProductMix: (id: any) => {
    return BaseApi.DELETE(`api/Product/DeleteProductInfo?id=${id}`);
  },
  UpdateProductMix: (data: any) => {
    return BaseApi.PUT('api/Product/UpdateProductInfo', data);
  },
  CreateNewProductMix: (data: any) => {
    return BaseApi.POST('api/Product/CreateProductInfo', data);
  },
  // lấy danh mục sản phẩm đầu tiên vài cái thôi, cần có thêm chỗ search giống bên khách hàng để lấy nhiều hơn..
  GetInitProductMix: (page: number, size: number) => {
    return BaseApi.GET(`api/Product/GetPaging?page=${page}&size=${size}`);
  },
  // API quản  lý dữ liệu các thiết bị
  // + Loại thiết bị
  DeleteProductType: (id: any) => {
    return BaseApi.DELETE(`api/Product/DeleteProductType?id=${id}`);
  },
  UpdateProductType: (data: any) => {
    return BaseApi.PUT('api/Product/UpdateProductType', data);
  },
  CreateProductType: (data: any) => {
    return BaseApi.POST('api/Product/CreateProductType', data);
  },
  GetProductTypeList: () => {
    return BaseApi.GET('api/Product/GetAllProductType');
  },
  SearchProductMix: (
    textValue?: any,
    productTypeId?: any,
    productBranchId?: any,
    productCategoryId?: any,
    isActive?: any
  ) => {
    return BaseApi.GET(
      `api/Product/Search?searchText=${textValue}&productTypeId=${productTypeId}&productBranchId=${productBranchId}&productCategoryId=${productCategoryId}&isActive=${isActive}`
    );
  },
  // + Nhóm sản phẩm
  DeleteProductCate: (id: any) => {
    return BaseApi.DELETE(`api/Product/DeleteProductCategory?id=${id}`);
  },
  UpdateProductCate: (data: any) => {
    return BaseApi.PUT('api/Product/UpdateProductCategory', data);
  },
  CreateProductCate: (data: any) => {
    return BaseApi.POST('api/Product/CreateProductCategory', data);
  },
  CreateProductCateQuickVAT: (data: any) => {
    return BaseApi.POST('api/Product/SetVatValueFromCategory', data);
  },
  GetProductCateList: () => {
    return BaseApi.GET('api/Product/GetAllProductCategory');
  },
  // + Nhãn hiệu thiết bị
  DeleteProductBrand: (id: any) => {
    return BaseApi.DELETE(`api/Product/DeleteProductBranch?id=${id}`);
  },
  UpdateProductBrand: (data: any) => {
    return BaseApi.PUT('api/Product/UpdateProductBranch', data);
  },
  CreateProductBrand: (data: any) => {
    return BaseApi.POST('api/Product/CreateProductBranch', data);
  },
  GetProductBrandList: () => {
    return BaseApi.GET('api/Product/GetAllProducBranch');
  },
  // + Danh sách lỗi thường gặp
  DeleteRegularWeak: (id: any) => {
    return BaseApi.DELETE(`api/Error/DeleteV2?id=${id}`);
  },
  UpdateRegularWeak: (data: any) => {
    return BaseApi.PUT('api/Error/Update', data);
  },
  UpdateRegularWeakV2: (data: any) => {
    return BaseApi.PUT('api/Error/UpdateV2', data);
  },
  UpdateRegularWeakV3: (data: any) => {
    return BaseApi.PUT('api/Error/UpdateV3', data);
  },
  CreateRegularWeak: (data: any) => {
    return BaseApi.POST('api/Error/Create', data);
  },
  CreateRegularWeakV2: (data: any) => {
    return BaseApi.POST('api/Error/CreateV2', data);
  },
  CreateArrayRegularWeakV2: (data: any) => {
    return BaseApi.POST('api/Error/CreateMultiV2', data);
  },
  CreateRegularWeakV3: (data: any) => {
    return BaseApi.POST('api/Error/CreateV3', data);
  },
  GetRegularWeakList: () => {
    return BaseApi.GET('api/Error/GetAll');
  },
  GetRegularWeakListV2: () => {
    return BaseApi.GET('api/Error/GetAllV2');
  },
  GetRegularWeakListV3: () => {
    return BaseApi.GET('api/Error/GetAllV3');
  },
  // Cách xử lý
  GetHandleErrorListV2: () => {
    return BaseApi.GET('api/ErrorHandling/GetAllV2');
  },
  GetHandleErrorListV3: () => {
    return BaseApi.GET('api/ErrorHandling/GetAllV3');
  },
  SuggestErrorHandleV2: (data: any) => {
    return BaseApi.POST('api/ErrorHandling/SuggestHandlingV2', data);
  },
  CreateErrorHandleV2: (data: any) => {
    return BaseApi.POST('api/ErrorHandling/CreateV2', data);
  },
  CreateErrorHandleV3: (data: any) => {
    return BaseApi.POST('api/ErrorHandling/CreateV3', data);
  },
  CreateArrayErrorHandleV2: (data: any) => {
    return BaseApi.POST('api/ErrorHandling/CreateMultiV2', data);
  },
  UpdateErrorHandleV2: (data: any) => {
    return BaseApi.PUT('api/ErrorHandling/UpdateV2', data);
  },
  UpdateErrorHandleV3: (data: any) => {
    return BaseApi.PUT('api/ErrorHandling/UpdateV3', data);
  },
  DeleteErrorHandleV2: (id: any) => {
    return BaseApi.DELETE(`api/ErrorHandling/DeleteV2?id=${id}`);
  },
  // Bộ thiết bị
  DeleteSetProduct: (id: any) => {
    return BaseApi.DELETE(`api/Product/DeleteProductSetsV2?id=${id}`);
  },
  UpdateSetProduct: (data: any) => {
    return BaseApi.PUT('api/Product/UpdateProductSetsV2', data);
  },
  CreateSetProduct: (data: any) => {
    return BaseApi.POST('api/Product/CreateProductSetsV2', data);
  },
  GetSetProductList: () => {
    return BaseApi.GET('api/Product/GetAllProductSetV2');
  },
  GetSetProductById: (id: any) => {
    return BaseApi.GET(`api/Product/GetDetailOfProductSet?id=${id}`);
  }
};

export default ProductManagementApi;
